import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as socketIo from 'socket.io-client';
import { environment } from 'src/environments/environment';
declare var $: any
let isAlreadyCalling = false;
let getCalled = false;

const existingCalls = [];

const { RTCPeerConnection, RTCSessionDescription } = window;


@Component({
  selector: 'app-video-call',
  templateUrl: './video-call.component.html',
  styleUrls: ['./video-call.component.css']
})
export class VideoCallComponent implements OnInit {
  sendMessages = [];
  ioConnection: any;
  messageContent: string;
  // socket;
  users = [];
  UserType; AdminNameOfUser; AdminNameOfAdmin;
  StaffID; PatientID; Who; RoomID; isCaller = false
  iceServers = {
    'iceServers': [
      { 'urls': 'stun:stun.services.mozilla.com' },
      { 'urls': 'stun:stun.l.google.com:19302' }
    ]
  }
  peerConnection = new RTCPeerConnection();
  localStream; remoteStream; isSuccess = false
  shouldFaceUser = true;
  videoCdnUrl=environment.googleCDNUrl;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    // { transports: ['websocket'] }
    // const socket = socketIo.connect("localhost:3000");
    const socket = socketIo.connect(environment.configUrl);

    var urlParams = new URLSearchParams(window.location.search);
    this.StaffID = urlParams.get('StaffID')
    this.PatientID = urlParams.get('PatientID')
    this.Who = urlParams.get('Who')
    this.RoomID = urlParams.get('UniqueID')

    const newRef = this
    socket.emit('create or join', newRef.RoomID);

    // message handlers
    socket.on('created', function (room) {
      console.log("created")
      const supports = navigator.mediaDevices.getSupportedConstraints();
      if (!supports['facingMode']) {
        alert('This browser does not support facingMode!');
      }
      navigator.mediaDevices.getUserMedia(
        {
          video: {
            facingMode: newRef.shouldFaceUser ? 'user' : 'environment'
          },
          audio: true
        }).then(stream => {
          const localVideo: any = document.getElementById("local-video");
          if (localVideo) {
            localVideo.srcObject = stream;
            newRef.localStream = stream
            localVideo.muted = true
          }
          newRef.isCaller = true;
        }, err => {
          console.warn(err.message);
        })
    });

    socket.on('joined', function (room) {
      navigator.mediaDevices.getUserMedia(
        {
          video: {
            facingMode: newRef.shouldFaceUser ? 'user' : 'environment'
          },
          audio: true
        }).then(stream => {
          console.log("join")
          const localVideo: any = document.getElementById("local-video");
          if (localVideo) {
            localVideo.srcObject = stream;
            newRef.localStream = stream
            localVideo.muted = true
          }
          socket.emit('ready', room);
        }, err => {
          console.warn(err.message);
        })
    })

    socket.on('candidate', function (event) {
      console.log("candidate")
      var candidate = new RTCIceCandidate({
        sdpMLineIndex: event.label,
        candidate: event.candidate
      });
      newRef.peerConnection.addIceCandidate(candidate);
    });

    socket.on('ready', function () {
      console.log("ready")

      if (newRef.isCaller) {
        newRef.peerConnection = new RTCPeerConnection(newRef.iceServers);
        newRef.peerConnection.onicecandidate = onIceCandidate;
        newRef.peerConnection.ontrack = onAddStream;
        newRef.peerConnection.addTrack(newRef.localStream.getTracks()[0], newRef.localStream);
        newRef.peerConnection.addTrack(newRef.localStream.getTracks()[1], newRef.localStream);
        newRef.peerConnection.createOffer()
          .then(sessionDescription => {
            newRef.peerConnection.setLocalDescription(sessionDescription);
            socket.emit('offer', {
              type: 'offer',
              sdp: sessionDescription,
              room: newRef.RoomID
            });
          })
          .catch(error => {
            console.log(error)
          })
      }
    });

    socket.on('offer', function (event) {
      console.log("offer")

      if (!newRef.isCaller) {
        newRef.peerConnection = new RTCPeerConnection(newRef.iceServers);
        newRef.peerConnection.onicecandidate = onIceCandidate;
        newRef.peerConnection.ontrack = onAddStream;
        newRef.peerConnection.addTrack(newRef.localStream.getTracks()[0], newRef.localStream);
        newRef.peerConnection.addTrack(newRef.localStream.getTracks()[1], newRef.localStream);
        newRef.peerConnection.setRemoteDescription(new RTCSessionDescription(event));
        newRef.peerConnection.createAnswer()
          .then(sessionDescription => {
            newRef.peerConnection.setLocalDescription(sessionDescription);
            socket.emit('answer', {
              type: 'answer',
              sdp: sessionDescription,
              room: newRef.RoomID
            });
          })
          .catch(error => {
            console.log(error)
          })
      }
    });

    socket.on('answer', function (event) {
      console.log("answer")
      newRef.peerConnection.setRemoteDescription(new RTCSessionDescription(event));
    })

    $('#disconnectCall').on('click', function () {
      newRef.peerConnection.close()
      const localVideo: any = document.getElementById("local-video");
      const remoteVideo: any = document.getElementById("remote-video");
      localVideo.srcObject = null
      remoteVideo.srcObject = null
      newRef.isSuccess = true
      $('.video-chat-container').addClass('d-none')
      $('.thank-msg').removeClass('d-none')
      let stateObj = { id: "100" };
      window.history.replaceState(stateObj,
        "Home", "/");
    })

    // handler functions
    function onIceCandidate(event) {
      if (event.candidate) {
        console.log('sending ice candidate');
        socket.emit('candidate', {
          type: 'candidate',
          label: event.candidate.sdpMLineIndex,
          id: event.candidate.sdpMid,
          candidate: event.candidate.candidate,
          room: newRef.RoomID
        })
      }
    }

    function onAddStream(event) {
      console.log("remote")

      const remoteVideo: any = document.getElementById("remote-video");
      if (remoteVideo) {
        $('.remote-video-text').addClass('d-none')
        $('#remote-video').removeClass('d-none')
        $('#remote-video').addClass('d-block')
        remoteVideo.srcObject = event.streams[0];
        newRef.remoteStream = event.stream
      }
    }

  }

  disconnect() {
    $('#ModalCenterAlert').modal('show')
  }

  closeConnection() {
    $('#ModalCenterAlert').modal('hide')
  }

  close() {
    $('#ModalCenter').modal('hide')
    $('.video-chat-container').addClass('d-none')
    $('.thank-msg').removeClass('d-none')
    window.top.close()
  }

  muteVideo() {
    const localVideo: any = document.getElementById("local-video");
    localVideo.srcObject.getAudioTracks().forEach(t => t.enabled = !t.enabled);
    if ($('.mute-audio').hasClass('fa-microphone')) {
      $('.mute-audio').removeClass('fa-microphone')
      $('.mute-audio').addClass('fa-microphone-slash')
    } else {
      $('.mute-audio').addClass('fa-microphone')
      $('.mute-audio').removeClass('fa-microphone-slash')
    }
  }

  fullScreen() {
    const remoteVideo: any = document.getElementById("remote-video");
    remoteVideo.requestFullscreen();
  }

  flipCamera() {
    this.shouldFaceUser = !this.shouldFaceUser
    navigator.mediaDevices.getUserMedia(
      {
        video: {
          facingMode: this.shouldFaceUser ? 'user' : 'environment'
        },
        audio: true
      }).then(stream => {
        const localVideo: any = document.getElementById("local-video");
        if (localVideo) {
          localVideo.srcObject = stream;
          this.localStream = stream
          localVideo.muted = true
        }
        // this.isCaller = true;
      }, err => {
        console.warn(err.message);
      })

  }
}
    // remoteVideo.srcObject = null


  // socket.
    // this.JoinRoom(this.RoomID)
  // JoinRoom(RoomID) {
  //   this.socket.on('join',({RoomID}))
  // }
// this.route.params.subscribe(params => {
//   if (params && params['Type']) {
//     this.UserType = params['Type']
//     if (this.UserType === 'Admin') {
//       socket.on("update-user-list", ({ users }) => {
//         updateUserList(users);
//       });
//     }

//     if (this.UserType === 'User') {
//       socket.on("update-user-list", ({ users }) => {
//         updateUserList(users);
//       });
//     }
//   }
// })

// async function callUser(socketId) {
//   if (newRef.UserType === 'Admin') {
//     const offer = await this.peerConnection.createOffer();
//     await this.peerConnection.setLocalDescription(new RTCSessionDescription(offer));

//     socket.emit("call-user", {
//       offer,
//       to: socketId
//     });
//   }

// }

// async function recieveCall(SocketID) {
//   console.log("hfjdhv")
//   // await this.peerConnection.setRemoteDescription(
//   //   new RTCSessionDescription(data.offer)
//   // );
//   const answer = await this.peerConnection.createAnswer();
//   await this.peerConnection.setLocalDescription(new RTCSessionDescription(answer));

//   socket.emit("make-answer", {
//     answer,
//     to: SocketID
//   });
//   getCalled = true;
//   // socket.on('make-answer', async data => {
//   //   console.log(data, "dgfgdh")

//   // })

// }

// function updateUserList(socketIds) {
//   console.log("m mnbmnbcvm", socketIds)

//   if (socketIds) {
//     socketIds.forEach(socketId => {
//       if (socketId && socketId.Cookie) {
//         // const alreadyExistingUser = document.getElementById(socketId);
//         // if (!alreadyExistingUser) {
//         var socketsVal = []
//         socketsVal.push(socketId.Cookie.split('; '))
//         for (var i = 0; i < socketsVal[0].length; i++) {
//           console.log(socketsVal[0][i])
//           console.log("user", socketsVal[0][i].startsWith('UserType=User') && socketsVal[0][i].startsWith('VideoCallInitiater=A'))
//           console.log("user", socketsVal[0][i].startsWith('UserType=Admin') && socketsVal[0][i].startsWith('VideoCallInitiater=A'))
//           if (socketsVal[0][i].startsWith('UserType=User') && socketsVal[0][i].startsWith('VideoCallInitiater=A')) {
//             console.log("user")
//             callUser(socketsVal[i].Socket)
//           } else if (socketsVal[0][i].startsWith('UserType=Admin') && socketsVal[0][i].startsWith('VideoCallInitiater=A')) {
//             console.log("admin")
//             recieveCall(socketsVal[i].Socket)
//           }
//         }
//         // }
//       }
//     });
//   }
// }

// this.peerConnection.ontrack = function ({ streams: [stream] }) {
//   var remoteVideo: any = document.getElementById("remote-video");
//   if (remoteVideo) {
//     remoteVideo.srcObject = stream;
//   }
// };

// navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => {
//   const localVideo: any = document.getElementById("local-video");
//   if (localVideo) {
//     localVideo.srcObject = stream;
//   }

//   stream.getTracks().forEach(track => this.peerConnection.addTrack(track, stream));
// }, err => {
//   console.warn(err.message);
// })





// const newRef = this
// $('#muteVideo').on('click', function () {

// })

// $('#disconnetCall').on('click', function () {
//   socket.on('disconnect', () => {
//     console.log("disconn", socket)
//   })
// })

    // socket.on("call-made", async data => {
    //   console.log("m mnbmnbcvm", data)
    //   if (getCalled) {
    //     const confirmed = confirm(
    //       `User "Socket: ${data.socket}" wants to call you. Do accept this call?`
    //     );

    //     if (!confirmed) {
    //       socket.emit("reject-call", {
    //         from: data.socket
    //       });

    //       return;
    //     }
    //   }

    //   await this.peerConnection.setRemoteDescription(
    //     new RTCSessionDescription(data.offer)
    //   );
    //   const answer = await this.peerConnection.createAnswer();
    //   await this.peerConnection.setLocalDescription(new RTCSessionDescription(answer));

    //   socket.emit("make-answer", {
    //     answer,
    //     to: data.socket
    //   });
    //   getCalled = true;
    // });

    // function unselectUsersFromList() {
    //   const alreadySelectedUser = document.querySelectorAll(
    //     ".active-user.active-user--selected"
    //   );

    //   alreadySelectedUser.forEach(el => {
    //     el.setAttribute("class", "active-user");
    //   });
    // }

    // // function createUserItemContainer(socketId) {
    // //   const userContainerEl = document.createElement("div");

    // //   const usernameEl = document.createElement("p");

    // //   userContainerEl.setAttribute("class", "active-user");
    // //   userContainerEl.setAttribute("id", socketId);
    // //   usernameEl.setAttribute("class", "username");
    // //   usernameEl.innerHTML = `Socket: ${socketId}`;

    // //   userContainerEl.appendChild(usernameEl);

    // //   userContainerEl.addEventListener("click", () => {
    // //     unselectUsersFromList();
    // //     userContainerEl.setAttribute("class", "active-user active-user--selected");
    // //     const talkingWithInfo = document.getElementById("talking-with-info");
    // //     talkingWithInfo.innerHTML = `Talking with: "Socket: ${socketId}"`;
    // //     callUser(socketId);
    // //   });

    // //   return userContainerEl;
    // // }




    // // const socket = socketIo.connect(environment.configUrl);



    // socket.on("remove-user", ({ socketId }) => {
    //   const elToRemove = document.getElementById(socketId);

    //   if (elToRemove) {
    //     elToRemove.remove();
    //   }
    // });



    // socket.on("answer-made", async data => {
    //   await this.peerConnection.setRemoteDescription(
    //     new RTCSessionDescription(data.answer)
    //   );

    //   if (!isAlreadyCalling) {
    //     callUser(data.socket);
    //     isAlreadyCalling = true;
    //   }
    // });

    // socket.on("call-rejected", data => {
    //   alert(`User: "Socket: ${data.socket}" rejected your call.`);
    //   unselectUsersFromList();
    // });



    // navigator.getUserMedia({ video: true, audio: true },stream => {
    //     const localVideo: any = document.getElementById("local-video");
    //     if (localVideo) {
    //       localVideo.srcObject = stream;
    //     }

    //     stream.getTracks().forEach(track => this.peerConnection.addTrack(track, stream));
    //   },
    //   error => {
    //     console.warn(error.message);
    //   }
    // );
//   }


// }
